import React from "react";

import { FormHelper } from "../helpers"
import { FieldGroup } from "../components"
import { AddressFieldset, AjaxForm } from "./index.jsx"

const AddressForm = ({
    address, nameObject,
    afterSubmit, submitLabel, url = false, submitAction,
    secondButton,
    successTitle = "Changed saved!",
    showName = false, showPhone = false,
    autoSave = false,
}) => {
    const fields = [
        'country_id', 'line1', 'line2', 'postal_code', 'locality', 'region'
    ]

    const requiredFields = [
        'country_id', 'line1', 'locality', 'postal_code'
    ]

    if (showName) {
        fields.push('first_name')
        fields.push('last_name')

        requiredFields.push('first_name')
        requiredFields.push('last_name')
    }

    if (showPhone) {
        fields.push('phone')
        requiredFields.push('phone')
    }

    const formProps = {
        method: "put",
        url,
        fields,
        requiredFields,
        initialValues: FormHelper.initialValues(fields, address),
        submitAction,
        afterSubmit,
        secondButton,
        submitLabel,
        successTitle,
        autoSave,
    }

    return (
        <AjaxForm {...formProps}>
            { showName && (
                <>
                    <div className="row">
                        <div className="col-md-6 pr-16">
                            <FieldGroup
                                placeholder="First Name"
                                nameObject={nameObject}
                                name="first_name"
                            />
                        </div>

                        <div className="col-md-6">
                            <FieldGroup
                                placeholder="Last Name"
                                nameObject={nameObject}
                                name="last_name"
                            />
                        </div>
                    </div>
                </>
            )}

            { showPhone && (
                <FieldGroup
                    placeholder="Phone"
                    type="phone"
                    nameObject={nameObject}
                    name="phone"
                />
            )}

            <AddressFieldset nameObject={nameObject} />
        </AjaxForm>
    )
}

export default AddressForm
